(ns hypnos.sleeplab.panel.dashboard
  "The sleeplan dashboard page."
  (:require [hypnos.config :as config]
            [hypnos.graphql.queries :as queries]
            [hypnos.i18n :refer [tr]]
            [hypnos.sleeplab.tile.consults :as consults]
            [re-frame.core :as rf]
            [reagent.core :as reagent]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Panel

(defn panel
  "The home panel"
  []
  (let [organization (rf/subscribe [:sleeplab/organization])
        state        (reagent/atom {:organization @organization})
        org-ids      (if (:organization/id @organization)
                       [(str (:organization/id @organization))]
                       [])]
    (rf/dispatch [:amplify/query
                  queries/get-consults
                  {:limit  config/PAGE-SIZE
                   :offset 0
                   :filter {:organization_ids org-ids}}
                  :sleeplab/set-consults
                  :sleeplab/noop])
    (fn []
      (let [org      (rf/subscribe [:sleeplab/organization])
            loading? (rf/subscribe [:sleeplab/gql-request-in-progress?])]
        (when (not= (get-in @state [:organization :organization/id]) (:organization/id @org))
          (rf/dispatch [:amplify/query
                        queries/get-consults
                        {:limit  config/PAGE-SIZE
                         :offset 0
                         :filter {:organization_ids [(str (:organization/id @org))]}}
                        :sleeplab/set-consults
                        :sleeplab/noop])
          (swap! state assoc :organization @org))
        [:section.section.is-main-section
         ;; pending consults
         [:div.card.has-table.has-mobile-sort-spaced
          [:div.card-header
           [:p.card-header-title
            [:span.icon [:i.mdi.mdi-18px.mdi-handshake]]
            (tr :ui.label/pending-recommendations)]
           [:button.button.is-small
            {:type     :button
             :disabled @loading?
             :on-click (fn [_]
                         (rf/dispatch [:amplify/query
                                       queries/get-consults
                                       {:limit  config/PAGE-SIZE
                                        :offset 0
                                        :filter {:organization_ids [(str (:organization/id @org))]}}
                                       :sleeplab/set-consults
                                       :sleeplab/noop]))}
            [:span.icon
             [:i.mdi.mdi-refresh.default]]
            [:span (tr :ui.label/refresh)]]]
          [:div.card-content
           [consults/consults-tile #{:consult-state/pending}]]]
         ;; upcoming consults
         [:div.card.has-table.has-mobile-sort-spaced
          [:div.card-header
           [:p.card-header-title
            [:span.icon
             [:i.mdi.mdi-18px.mdi-handshake]]
            (tr :ui.label/active-consults)]]
          [:div.card-content
           [consults/consults-tile #{:consult-state/new :consult-state/in-progress}]]]]))))
